(function () {
  const containers = document.querySelectorAll('[class*="newsletter-signup--"]');
  containers.forEach(init);

  function init(root) {
    const locale = root.dataset.shopLocale || 'de';
    const errorText = root.dataset.errorText || '';
    const isLoggedIn = root.dataset.customer === '1';
    const apiUrl = `/apps/gated-download/newsletter?locale=${encodeURIComponent(locale)}`;

    if (root.dataset.customer === '1') {
      checkStatus();
    }

    root.querySelectorAll('[data-newsletter-form]').forEach((form) => {
      form.addEventListener('submit', (event) => onSubmit(event, form));
    });

    async function checkStatus() {
      try {
        const res = await fetch(apiUrl, { credentials: 'same-origin' });
        const data = await res.json();
        if (data.state === 'subscribed') {
          applyPersonalisation(data.firstName);
          setState('subscribed');
        } else if (data.state === 'not_subscribed') {
          applyPersonalisation(data.firstName);
          setState('not_subscribed');
        } else if (data.state === 'error') {
          showError(data.reason || errorText);
        } else {
          setState('anonymous');
        }
      } catch (err) {
        console.error('[newsletter-signup] status error:', err);
        showError(errorText);
      }
    }

    async function onSubmit(event, form) {
      event.preventDefault();
      const data = new FormData(form);
      const email = String(data.get('email') || '').trim();
      const firstName = String(data.get('firstName') || '').trim();
      const consent = data.get('consent') === 'on' || data.get('consent') === 'true';
      if (!email) return;

      const button = form.querySelector('[data-submit-button]');
      const errorEl = form.querySelector('[data-error-message]');
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      if (button) {
        button.disabled = true;
        button.textContent = button.dataset.loadingText || button.textContent;
      }

      try {
        const res = await fetch(apiUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            firstName: firstName || null,
            consent,
            source: 'sewsimple-storefront',
          }),
        });
        const result = await res.json();

        if (!result.success) {
          if (errorEl) {
            errorEl.textContent = result.message || errorText;
            errorEl.hidden = false;
          }
          resetButton(button);
          return;
        }

        if (result.alreadySubscribed) {
          setState(isLoggedIn ? 'subscribed' : 'already_subscribed');
        } else {
          setState('success');
          if (window.Shopify?.analytics?.publish) {
            Shopify.analytics.publish('webnetz_newsletter_signup', {
              newsletter_position: 'section',
            });
          }
        }
      } catch (err) {
        console.error('[newsletter-signup] subscribe error:', err);
        if (errorEl) {
          errorEl.textContent = errorText;
          errorEl.hidden = false;
        }
        resetButton(button);
      }
    }

    function resetButton(button) {
      if (!button) return;
      button.disabled = false;
      button.textContent = button.dataset.defaultText || button.textContent;
    }

    function applyPersonalisation(firstName) {
      if (!firstName) return;
      root.querySelectorAll('[data-personal-greeting], [data-personal-heading]').forEach((el) => {
        const html = el.innerHTML;
        if (html.includes('{{firstName}}') || html.includes('{firstName}')) {
          el.innerHTML = html
            .replace(/\{\{firstName\}\}/g, escapeHtml(firstName))
            .replace(/\{firstName\}/g, escapeHtml(firstName));
        }
      });
    }

    function setState(state) {
      root.setAttribute('data-active', state);
    }

    function showError(message) {
      const errorEl = root.querySelector('[data-error-text]');
      if (errorEl && message) errorEl.textContent = message;
      setState('error');
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
})();
